module.exports = __webpack_public_path__ + "montserrat-regular-webfont.69eac499e9311b03ed69.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.ttf
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.ttf
// module chunks = 11